import { Button, CircularProgress, Switch, TextField } from "@material-ui/core"
import Topo from "../../../../Componentes/TopCategorias"
import { useStyles } from "./style"
import mercadoPagoLogo from "../../../../Assets/img/mercado-pago-logo.png"
import pix from "../../../../Assets/img/pix.png"
import { useEffect, useState } from "react"
import api from "../../../../Services/api"
import CustomAlert from "../../../../Componentes/Alerts/CustomAlert"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import mastercard from "../../../../Assets/img/mastercard.png"
import visa from "../../../../Assets/img/visa.png"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import CachedIcon from "@material-ui/icons/Cached"

const handleApiError = (
  error,
  defaultMessage = "Erro ao processar a requisição"
) => {
  if (error?.error) {
    return error.data || defaultMessage
  }
  if (error?.response?.data?.data) {
    return error.response.data.data
  }
  if (error?.response?.data?.error) {
    return error.response.data.data || defaultMessage
  }
  return defaultMessage
}

function CheckoutMercadoPago() {
  const [enableMercadoPagoIntegration, setEnableMercadoPagoIntegration] =
    useState(false)
  const [enableCreditCardPayment, setEnableCreditCardPayment] = useState(false)
  const [enablePixPayment, setEnablePixPayment] = useState(false)
  const [accessToken, setAccessToken] = useState("")
  const [publicKey, setPublicKey] = useState("")
  const [installments, setInstallments] = useState("12")
  const shopId = localStorage.getItem("id")
  const [alertMessage, setAlertMessage] = useState("")
  const [alertType, setAlertType] = useState("success")
  const [showModalAlert, setShowModalAlert] = useState(false)
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [currentPayment, setCurrentPayment] = useState({})
  const [isEdit, setIsEdit] = useState(false)
  const [paymentsActive, setPaymentsActive] = useState()
  const [integrationStatus, setIntegrationStatus] = useState({
    isOnline: false,
    message: "API de registro de status inativa",
    code: "341"
  })

  const classes = useStyles()

  // // Mantém consistência: se nenhum método estiver ativo, desativa o toggle principal
  // useEffect(() => {
  //   if (
  //     enableMercadoPagoIntegration &&
  //     !enableCreditCardPayment &&
  //     !enablePixPayment
  //   ) {
  //     setEnableMercadoPagoIntegration(false)
  //   }
  // }, [enableCreditCardPayment, enablePixPayment])

  const handleChangePublicKey = event => {
    setPublicKey(event.target.value)
  }

  const handleChangeAccessToken = event => {
    setAccessToken(event.target.value)
  }

  async function updatePayment() {
    const isMercadoPagoActive =
      enableMercadoPagoIntegration && (enablePixPayment || enableCreditCardPayment)

    const nextPaymentActive = isMercadoPagoActive
      ? "mercadopago"
      : paymentsActive?.pagseguro === 1
      ? "pagseguro"
      : "manual"

    const body = {
      lojinha_id: shopId,
      payment_active: nextPaymentActive,
      payment_data: {
        ...currentPayment.payment_data,
        payhow: {
          mercadopago: isMercadoPagoActive ? 1 : 0,
          pagseguro: 0,
          gateway: 0
        }
      }
    }

    localStorage.setItem(
      "active_checkout",
      isMercadoPagoActive ? "mercadopago" : "manual"
    )

    await api.put(`/lojinha/payment/update/${currentPayment.id}`, body)
  }

  async function saveMercadoPagoData() {
    setLoading(true)

    const body = {
      payment_id: localStorage.getItem("payment_id"),
      credit_card: enableMercadoPagoIntegration
        ? enableCreditCardPayment
          ? 1
          : 0
        : 0,
      pix: enableMercadoPagoIntegration ? (enablePixPayment ? 1 : 0) : 0,
      credentials: {
        access_token: accessToken,
        public_key: publicKey,
        installments: installments
      }
    }

    try {
      const { data } = await api.post(`/payhow/mercadopago/${shopId}`, body)
      if (data.error) {
        setAlertMessage(
          handleApiError(data, "Erro ao salvar integração com Mercado Pago!")
        )
        setAlertType("error")
        setShowModalAlert(true)
        setLoading(false)
        return
      }

      const IntegrationAuth = await integrationVerify()

      if (!enableMercadoPagoIntegration) {
        setLoading(false)
        setShowModalAlert(true)
        setAlertType("success")
        setAlertMessage("Alterado para checkout manual!")
        updatePayment()
        return
      }

      if (!enableCreditCardPayment && !enablePixPayment) {
        setLoading(false)
        setShowModalAlert(true)
        setAlertType("success")
        setAlertMessage("Alterado para checkout manual!")
        updatePayment()
        return
      }

      if (IntegrationAuth.status === 1) {
        const creditCardOk =
          !enableCreditCardPayment ||
          IntegrationAuth.credit_card?.authenticated === 1
        const pixOk = !enablePixPayment || IntegrationAuth.pix?.authenticated === 1

        if (creditCardOk && pixOk) {
          setLoading(false)
          setShowModalAlert(true)
          setAlertType("success")
          setAlertMessage(
            isEdit
              ? "Integração com Mercado Pago alterada com sucesso!"
              : "Integração com Mercado Pago criada com sucesso!"
          )
          updatePayment()
          return
        }

        setAlertMessage("Erro de autenticação nos métodos de pagamento selecionados")
        setAlertType("error")
        setShowModalAlert(true)
        setLoading(false)
        updatePayment()
      } else {
        setAlertMessage(
          "Erro na integração com Mercado Pago. Verifique suas credenciais."
        )
        setAlertType("error")
        setShowModalAlert(true)
        setLoading(false)
        updatePayment()
      }
    } catch (error) {
      setAlertMessage(
        handleApiError(error, "Erro ao salvar integração com Mercado Pago!")
      )
      setAlertType("error")
      setShowModalAlert(true)
      setLoading(false)
      updatePayment()
    }
  }

  async function integrationVerify() {
    try {
      const { data } = await api.get(`payhow/mercadopago/verify/${shopId}`)
      const result = data.data
      const isOnline =
        result.status === 1 &&
        ((result.credit_card?.authenticated === 1 &&
          result.credit_card?.enable === 1) ||
          (result.pix?.authenticated === 1 && result.pix?.enable === 1))

      setIntegrationStatus({
        isOnline,
        message: isOnline
          ? "Integração ativa e funcionando"
          : "API de registro de status inativa",
        code: isOnline ? "200" : "341"
      })

      return result
    } catch (error) {
      console.error(error)
      setIntegrationStatus({
        isOnline: false,
        message: "Erro ao verificar status da integração",
        code: "500"
      })
      return { status: 0 }
    }
  }

  const getInformations = async () => {
    setLoading(true)

    try {
      const { data } = await api.get(`/lojinha/payment/get/${shopId}`)
      setPaymentsActive(data.data.payment_data.payhow)
      setCurrentPayment(data.data)
      setEnableMercadoPagoIntegration(
        data.data.payment_data.payhow.mercadopago === 1 ? true : false
      )
      const integration = await api.get(`/payhow/info/${shopId}`)

      const payhowData = integration?.data?.data

      if (payhowData) {
        const mercadoPagoPayments = payhowData.filter(
          obj => obj.name === "Mercado Pago"
        )

        if (mercadoPagoPayments.length > 0) {
          setIsEdit(true)

          const creditCardConfig = mercadoPagoPayments.find(
            obj => obj.type === "credit_card"
          )
          const pixConfig = mercadoPagoPayments.find(obj => obj.type === "pix")

          if (creditCardConfig) {
            setEnableCreditCardPayment(creditCardConfig.enable === 1)
            setAccessToken(creditCardConfig.credentials.access_token || "")
            setPublicKey(creditCardConfig.credentials.public_key || "")
            setInstallments(creditCardConfig.credentials.installments || "12")
          }

          if (pixConfig) {
            setEnablePixPayment(pixConfig.enable === 1)
          }
        }
      }
    } catch (error) {
      console.error("Erro ao obter informações:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const init = async () => {
      await getInformations()
      const integration = await api.get(`/payhow/info/${shopId}`)
      const payhowData = integration?.data?.data
      if (payhowData) {
        const mercadoPagoPayments = payhowData.filter(
          obj => obj.name === "Mercado Pago"
        )
        const hasActivePayment = mercadoPagoPayments.some(obj => obj.enable === 1)
        if (hasActivePayment) {
          await integrationVerify()
        }
      }
    }
    init()
  }, [])

  return (
    <div className="page-container">
      <div className="page-align">
        <div>
          <Topo name="Integração com Mercado Pago" />
        </div>
        <div className={`${classes.pagseguroOrders} infinite-scroll`}>
          {loading ? (
            <div
              style={{
                display: "flex",
                height: "100%",
                minHeight: "100%",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <CircularProgress color="secondary" />
            </div>
          ) : (
            <div className="infinite-scroll">
              <div className={classes.enableMercadoPagoIntegrationContainer}>
                <h2>Habilitar integração</h2>
                <Switch
                  checked={enableMercadoPagoIntegration}
                  onChange={async () => {
                    const newValue = !enableMercadoPagoIntegration
                    setEnableMercadoPagoIntegration(newValue)
                    if (!newValue) {
                      setEnableCreditCardPayment(false)
                      setEnablePixPayment(false)
                    }
                    if (newValue) {
                      await integrationVerify()
                    }
                  }}
                />
              </div>
              <p className={classes.partnerContainer}>
                Em parceria com o
                <img
                  src={mercadoPagoLogo}
                  alt="Mercado pago logo"
                  style={{ width: "100px", marginLeft: "10px" }}
                />
              </p>
              {enableMercadoPagoIntegration === true ||
              enableMercadoPagoIntegration === 1 ? (
                <div className={classes.paymentOptionsContainer}>
                  <div className={classes.paymentOptionSwitchContainer}>
                    <div className={classes.paymentOptionSwitchLabelContainer}>
                      <p className={classes.paymentOptionSwitchLabel}>
                        Cartões de crédito
                      </p>
                      <div className={classes.paymentMethodContainer}>
                        <img src={mastercard} alt="mastercard" />
                        <img src={visa} alt="visa" />
                      </div>
                    </div>
                    <div>
                      <div className={classes.switchLabelContainer}>
                        <h3>Habilitar esta forma de pagamento</h3>

                        <Switch
                          checked={enableCreditCardPayment}
                          onChange={() =>
                            setEnableCreditCardPayment(!enableCreditCardPayment)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <hr style={{ width: "100%", margin: "0px" }} />
                  <div className={classes.paymentOptionSwitchContainer}>
                    <div className={classes.paymentOptionSwitchLabelContainer}>
                      <p className={classes.paymentOptionSwitchLabel}>PIX</p>
                      <div className={classes.paymentMethodContainer}>
                        <img src={pix} alt="pix" />
                      </div>
                    </div>
                    <div>
                      <div className={classes.switchLabelContainer}>
                        <h3>Habilitar esta forma de pagamento</h3>

                        <Switch
                          checked={enablePixPayment}
                          onChange={() => setEnablePixPayment(!enablePixPayment)}
                        />
                      </div>
                    </div>
                  </div>
                  <hr style={{ width: "100%", margin: "0px" }} />
                  <div
                    className={classes.taxesAndTariffsContainer}
                    onClick={() => history.push("/taxas-tarifas-mercado-pago")}
                  >
                    <div className={classes.taxesAndTariffsContainerInfo}>
                      <h3>Taxas e tarifas</h3>
                      <p>
                        Veja aqui quais são as taxas e tarifas de processamento das
                        suas vendas na loja.
                      </p>
                    </div>
                    <div>
                      <ArrowForwardIosIcon fontSize="small" color="disabled" />
                    </div>
                  </div>

                  <div>
                    <p>Código - Access Token</p>
                    <TextField
                      disabled={!enableCreditCardPayment && !enablePixPayment}
                      fullWidth
                      color="secondary"
                      variant="outlined"
                      multiline
                      rows={6}
                      value={accessToken}
                      onChange={handleChangeAccessToken}
                      style={{ backgroundColor: "#ffffff" }}
                      placeholder="Token do Mercado Pago"
                    />
                  </div>
                  <div>
                    <p>Código - Public Key</p>
                    <TextField
                      disabled={!enableCreditCardPayment && !enablePixPayment}
                      fullWidth
                      color="secondary"
                      variant="outlined"
                      multiline
                      rows={6}
                      value={publicKey}
                      onChange={handleChangePublicKey}
                      style={{ backgroundColor: "#ffffff" }}
                      placeholder="Chave pública do Mercado Pago"
                    />
                  </div>
                  <data className={classes.paymentOptionsContainer}>
                    <div className={classes.statusContainer}>
                      <div className={classes.statusRow}>
                        <div className={classes.statusRow}>
                          <div
                            className={classes.statusIndicator}
                            style={{
                              backgroundColor: integrationStatus.isOnline
                                ? "#4CAF50"
                                : "#f44336"
                            }}
                          />
                          <p className={classes.statusText}>
                            Status da integração:{" "}
                            {integrationStatus.isOnline ? "Online" : "Offline"}
                          </p>
                        </div>
                        <button
                          onClick={() => saveMercadoPagoData()}
                          className={classes.refreshButton}
                        >
                          <CachedIcon className={classes.refreshIcon} />
                        </button>
                      </div>
                      <p className={classes.errorText}>
                        {integrationStatus.isOnline
                          ? ""
                          : `Erro: ${integrationStatus.code} - ${integrationStatus.message}`}
                      </p>
                      <a
                        href="https://blog.uppyapp.com.br/2024/09/integracao-marcado-pago-mobile/"
                        className={classes.helpLink}
                      >
                        Não sabe como obter as informações essas informações?{" "}
                        <b>clique aqui</b>
                      </a>
                    </div>
                  </data>
                </div>
              ) : null}
            </div>
          )}
        </div>
        <div className="footer-column">
          <hr style={{ width: "100%" }} />
          <Button
            onClick={saveMercadoPagoData}
            className={classes.buttonSave}
            type="submit"
            variant="contained"
          >
            Salvar informações
          </Button>
        </div>
      </div>
      <CustomAlert
        type={alertType}
        alertText={alertMessage}
        show={showModalAlert}
        close={() => setShowModalAlert(false)}
      />
    </div>
  )
}

export default CheckoutMercadoPago
